
import { mapActions } from 'vuex'
import Cm24Article from '@/components/strapi/Cm24Article'
import TheLanding from '@/components/landing/TheLanding.vue'
import { Cms } from '@/helpers/cms'
import utils from '@/components/tools/utils'
import Product from '@/components/catalog/product/Product.vue'

export default {
  name: 'CatchAll',
  components: { Product, Cm24Article, TheLanding },
  async asyncData ({ app, from, error, route, $axios, $config, store, redirect }) {
    const path = route.path

    // we will replace this hack with a custom redirect module in strapi in the future
    if (path === '/wohnmobil-ankauf-ratgeber') {
      redirect('/wohnmobil-ankauf/ratgeber')
    }
    if (path === '/haendler-leitfaden') {
      redirect('/a/haendler-bereich/richtlinien')
    }

    const pathWithoutLeadingSlash = path.replace(/^\//, '')
    const splits = pathWithoutLeadingSlash?.split('/')

    let productId = null
    if (splits?.length >= 1) {
      const productIdIndex = splits[0].lastIndexOf('-') + 1
      productId = parseInt(splits[0].slice(productIdIndex))
    }

    if (
      !isNaN(productId) && !path.startsWith('/preisentwicklung') &&
      !path.startsWith('/prijs-ontwikkeling') &&
      !path.startsWith('/price-development') &&
      !path.startsWith('/wohnmobilmarkt-analyse')
    ) {
      return {
        productId,
        backToMyVehicles: from?.name.startsWith('account-products')
      }
    }

    const { locale } = app.i18n
    const cms = new Cms($axios)
    try {
      const getLandingsUrl = `${$config.cmsBaseURL}/api/landing-pages`
      const getLandingsParams = utils.getLandingPageParams(pathWithoutLeadingSlash)

      const { data: landings } = await cms.get(getLandingsUrl, {
        params: {
          ...getLandingsParams,
          locale,
          populate: 'localizations'
        }
      })

      if (landings.length > 0) {
        const routeParams = utils.getI18RouteParams(landings[0].attributes?.localizations, locale, pathWithoutLeadingSlash)

        await store.dispatch('i18n/setRouteParams', routeParams)

        if (landings[0].attributes?.hideFooter === true && path) {
          await store.dispatch('general/hideFooter', path)
        }

        if (landings[0].attributes?.hideNavbar === true && path) {
          await store.dispatch('general/hideNavbar', path)
        }

        return { landingAttributes: landings[0]?.attributes }
      }
    } catch (e) {
      console.error('Error fetching landing page:', e)
      error({
        statusCode: 404
      })
    }
    try {
      const articlesParams = utils.getArticlePageParams(pathWithoutLeadingSlash)

      const { data: articles } = await cms.get(`${$config.cmsBaseURL}/api/articles`, {
        params: {
          ...articlesParams,
          locale,
          populate: 'localizations'
        }
      })

      if (articles.length > 0) {
        const routeParams = utils.getI18RouteParams(articles[0].attributes.localizations, locale, pathWithoutLeadingSlash)
        await store.dispatch('i18n/setRouteParams', routeParams)
        return { article: articles[0].attributes }
      }
    } catch (e) {
      console.error('Error fetching article:', e)
      error({
        statusCode: 404
      })
    }

    console.info('No product, landing-page or article found at ', pathWithoutLeadingSlash)
    error({
      statusCode: 404
    })
  },

  data () {
    return {
      productId: null,
      fetchProduct: true,
      article: null,
      landingAttributes: null,
      backToMyVehicles: false
    }
  },

  mounted () {
    if (this.productId) {
      this.collect({
        action: 'view_pdp',
        productEntityId: this.productId
      })
    } else {
      this.collect({
        action: 'view'
      })
    }
  },
  methods: {
    ...mapActions('useractionlog', ['collect'])
  }
}
